import React, { Component, ErrorInfo } from 'react';

export interface ErrorBoundaryProps {
    fallback?: React.ReactNode;
    errorHandler?: (error: Error, errorInfo: ErrorInfo) => void;
}

type ErrorBoundaryState = {
    hasError: boolean;
    error: Error;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        if (this.props.errorHandler) {
            try {
                this.props.errorHandler(error, errorInfo);
            } catch (e) {
                console.error(e);
            }
        }
    }

    render() {
        if (this.state.hasError && this.props.fallback) {
            if (typeof this.props.fallback === 'function') {
                return this.props.fallback(this.state.error);
            } else {
                return this.props.fallback;
            }
        }

        return this.props.children;
    }
}
